import { __ } from '../../utils';
import NotificationsList from './NotificationsList';
import {
  Divider,
  IconButton,
  Popover,
  Stack,
  Typography,
} from '@presov.sk/presov-ui-react';
import { Settings } from '@mui/icons-material';
import React from 'react';
import { useNavigate } from 'react-router';

type Props = {
  id?: string;
  anchorEl: HTMLButtonElement | null;
  isOpen?: boolean;
  onClose: () => void;
};

const NotificationsPopup: React.FC<Props> = ({
  id,
  anchorEl,
  isOpen,
  onClose,
}) => {
  const navigate = useNavigate();

  return (
    <Popover
      id={id}
      open={isOpen}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
    >
      <Stack
        sx={{
          width: 360,
        }}
      >
        <Stack
          direction={'row'}
          alignItems={'center'}
          justifyContent={'space-between'}
          sx={{ py: 1, px: 2 }}
        >
          <Typography variant='h6'>{__('Notifikácie')}</Typography>
          <IconButton
            onClick={() => {
              onClose();
              navigate('/profil/nastavenia');
            }}
          >
            <Settings />
          </IconButton>
        </Stack>
      </Stack>
      <Divider />
      <NotificationsList
        onClose={onClose}
        // notifications={notifications}
        // isLoading={isLoading}
        isDesktop
      />
    </Popover>
  );
};

export default NotificationsPopup;
